import type { CSSProperties } from "react";

export const adminInputStyle: CSSProperties = {
  width: "100%",
  padding: "0.625rem 0.75rem",
  background: "var(--login-bg)",
  border: "1px solid var(--login-border)",
  borderRadius: "0.5rem",
  color: "var(--login-text)",
  fontFamily: "'DM Sans', sans-serif",
  fontSize: "0.9375rem",
  outline: "none",
  boxSizing: "border-box",
};

export const adminSelectStyle: CSSProperties = {
  ...adminInputStyle,
  appearance: "none",
  paddingRight: "2.25rem",
  backgroundImage: `url("data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 24 24' fill='none' stroke='%23888888' stroke-width='2.5' stroke-linecap='round' stroke-linejoin='round'><polyline points='6 9 12 15 18 9'/></svg>")`,
  backgroundRepeat: "no-repeat",
  backgroundPosition: "right 0.75rem center",
  backgroundSize: "0.75rem",
};

export const adminLabelStyle: CSSProperties = {
  fontFamily: "'Barlow Condensed', sans-serif",
  fontWeight: 600,
  fontSize: "0.75rem",
  letterSpacing: "0.06em",
  color: "var(--login-muted)",
};

export const adminPrimaryButtonStyle: CSSProperties = {
  flex: 1,
  padding: "0.75rem",
  background: "var(--login-accent)",
  border: "none",
  borderRadius: "0.5rem",
  color: "#fff",
  fontFamily: "'Barlow Condensed', sans-serif",
  fontWeight: 700,
  fontSize: "1rem",
  letterSpacing: "0.06em",
};

export const adminDangerButtonStyle: CSSProperties = {
  flex: 1,
  padding: "0.75rem",
  background: "transparent",
  border: "1px solid var(--login-error, #e05353)",
  borderRadius: "0.5rem",
  color: "var(--login-error, #e05353)",
  fontFamily: "'Barlow Condensed', sans-serif",
  fontWeight: 700,
  fontSize: "1rem",
  letterSpacing: "0.06em",
};

export const adminDrawerBodyStyle: CSSProperties = {
  display: "flex",
  flexDirection: "column",
  gap: "1rem",
};

export const adminFieldStyle: CSSProperties = {
  display: "flex",
  flexDirection: "column",
  gap: "0.375rem",
};

export const adminListStyle: CSSProperties = {
  display: "flex",
  flexDirection: "column",
  gap: "0.375rem",
};

export const adminMutedTextStyle: CSSProperties = {
  fontFamily: "'DM Sans', sans-serif",
  color: "var(--login-muted)",
  fontSize: "0.875rem",
};

export const adminAddButtonStyle: CSSProperties = {
  display: "inline-flex",
  alignItems: "center",
  gap: "0.45rem",
  padding: "0.72rem 0.95rem",
  background:
    "color-mix(in srgb, var(--login-accent) 88%, var(--login-surface))",
  border: "none",
  borderRadius: "0.95rem",
  color: "#fff",
  fontFamily: "'Barlow Condensed', sans-serif",
  fontWeight: 700,
  fontSize: "0.92rem",
  letterSpacing: "0.06em",
  cursor: "pointer",
  flexShrink: 0,
  transition: "transform 0.16s ease, opacity 0.16s ease",
};

export function adminListItemStyle(index: number): CSSProperties {
  return {
    animation: "adminFadeSlideIn 0.18s ease both",
    animationDelay: `${index * 0.04}s`,
  };
}
